// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".paper[data-v-270e47f2]{width:100%;min-height:100vh;background:#fff}.paper *[data-v-270e47f2]{font-family:\"Noto Sans KR\"}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
